import * as Dialog from "@radix-ui/react-dialog";

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  description: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: "danger" | "warning";
  onConfirm: () => void;
  onCancel: () => void;
}

export function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  variant = "danger",
  onConfirm,
  onCancel,
}: Readonly<ConfirmDialogProps>) {
  return (
    <Dialog.Root open={open} onOpenChange={(o) => !o && onCancel()}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-[1500] bg-ink/40 backdrop-blur-sm" />
        <Dialog.Content className="fixed left-1/2 top-1/2 z-[1501] w-full max-w-sm -translate-x-1/2 -translate-y-1/2 rounded-soft border border-rule bg-surface p-6 shadow-cardLift">
          <Dialog.Title asChild>
            <h2 className="font-display text-[18px] font-semibold tracking-tight text-ink">
              {title}
            </h2>
          </Dialog.Title>

          <Dialog.Description className="mt-2 text-[13.5px] leading-relaxed text-ash">
            {description}
          </Dialog.Description>

          <div className="mt-6 flex items-center justify-end gap-2">
            <button onClick={onCancel} className="btn-secondary">
              {cancelLabel}
            </button>
            <button
              onClick={() => {
                onConfirm();
              }}
              className={variant === "danger" ? "btn-danger" : "btn-primary"}
              autoFocus
            >
              {confirmLabel}
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
